import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { staff } from "../domain/data";
import { useForms } from "../state/forms";
import { ErrorFlash } from "../components/ErrorFlash";
import { PrototypeBanner, StaffNav } from "../components/ui";

export function StaffCreateForm() {
  const navigate = useNavigate();
  const { addForm, currentForm } = useForms();
  const [year, setYear] = useState("2027-2028");
  const [error, setError] = useState("");

  function onSubmit(event: FormEvent) {
    event.preventDefault();
    const result = addForm(year);
    if ("error" in result) {
      setError(result.error);
      return;
    }
    navigate(`/staff/forms/${result.id}`);
  }

  return (
    <div className="app">
      <PrototypeBanner />
      <main className="shell">
        <StaffNav />
        <p className="meta">
          Staff · {staff.given} {staff.family} · new form
        </p>
        <h1>New school-year form</h1>
        <p className="lede">
          Opens a fresh form and copies last year's design so you can tweak
          questions without starting over. Last year's answers stay saved.
        </p>

        {currentForm ? (
          <div className="wire dashed">
            <div className="meta">Will be archived, not deleted</div>
            <strong>{currentForm.name}</strong>
            <div className="anno">{currentForm.openedLabel} · still pullable</div>
          </div>
        ) : null}

        <form className="stack" onSubmit={onSubmit} style={{ marginTop: "1.25rem" }}>
          <div className="field">
            <label htmlFor="year">School year</label>
            <input
              id="year"
              type="text"
              value={year}
              onChange={(e) => setYear(e.target.value)}
              required
            />
          </div>

          {error ? <ErrorFlash key={error} message={error} /> : null}

          <div className="actions">
            <button type="submit">Save form</button>
            <Link className="btn ghost" to="/staff/forms">
              Cancel
            </Link>
          </div>
        </form>
      </main>
    </div>
  );
}
